<template>
  <div id="checkup-plus-index">
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${this.serviceSlug}`)},
        {title: this.$t(`checkup_plus.alerts.title`), disabled: true }
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>

    </Breadcrumbs>
    <div class="text-center" v-if="isLoading">
      <LoadingAnimation/>
    </div>
    <div v-else>
      <AlertsTable
        class="mt-1"
        :service="component.service"
        :showFilters="showFilters"
      />
    </div>

  </div>

</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";
import AlertsTable from "@/components/checkup_plus/alerts/AlertsTable.vue";
import Filters from '@/components/common/Filters';

export default {
  components: {Filters, AlertsTable, LoadingAnimation, Breadcrumbs},
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      isLoading: false,
      showFilters: true,
      activeFilters: 0
    }
  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
  }
}
</script>

<style scoped>

</style>
